import Flex from '@blocks/Flex'
import Hamburger from '@blocks/Hamburger'
import Logo from '@blocks/Logo'
import Navigation from './components/MainNavigation'
import { Container } from '@styles/helpers'
import { useSidepanelStateContext } from '@contexts/sidepanel'
import { route } from '@helpers'
import useAuth from '@hooks/useAuth'
import useSidepanel from '@hooks/useSidepanel'
import { ReactComponent as LogoutIcon } from '@icons/logout.svg'
import { ReactComponent as SettingsIcon } from '@icons/settings.svg'
import { desktop, mTablet } from '@styles/mixins'
import { colors } from '@styles/vars'
import { useMainTemplateContext } from '@templates/Main/context'
import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { ReactComponent as QuestionIcon } from '@icons/question.svg'
import MainSidemenu from './components/MainSidemenu'

function MainHeader() {
    const { category } = useMainTemplateContext()
    const { user, isCustomer, isAdmin, isJury, logout, hasDetails } = useAuth<Helpers.User>()

    const state = useSidepanelStateContext()
    const sidemenu = useSidepanel()
    const openSidemenu = () => sidemenu.open(MainSidemenu, { category })

    return (
        <HeaderContainer>
            <LogoWrapper>
                <Logo to={route(user.role.name)} />
            </LogoWrapper>
            <NavigationWrapper>
                <Navigation>
                    {/* CUSTOMER */}
                    <Navigation.Item label="Registration" to="" condition={isCustomer && !hasDetails} active={category === "details"} />
                    <Navigation.Item label="Profile" to={route("customer:profile")} condition={isCustomer && hasDetails} active={category === "profile"} />
                    <Navigation.Item label="Open Salons" to={route("customer:current")} condition={isCustomer && hasDetails} active={category === "current"} count={'current_count' in user ? user.current_count : undefined} />
                    <Navigation.Item label="Entries" to={route("customer:participating")} condition={isCustomer && hasDetails} active={category === "participating"} count={'participating_count' in user ? user.participating_count : undefined} />
                    <Navigation.Item label="Results" to={route("customer:past")} condition={isCustomer && hasDetails} active={category === "past"} />
                    <Navigation.Item label="Gallery" to={route("customer:gallery")} condition={isCustomer && hasDetails} active={category === "gallery"} />
                    <Navigation.Item label="Group" to={route("club:customer")} condition={isCustomer && hasDetails} active={category === "club"} />
                    {/* JURY */}
                    <Navigation.Item label="Salons" to={route("jury")} condition={isJury} active={category === "jury:salons"} />
                    {/* ADMIN */}
                    <Navigation.Item label="Salons" to={route("admin:salons")} condition={isAdmin} active={category === "salons"} />
                    <Navigation.Item label="Customers" to={route("admin:customers")} condition={isAdmin} active={category === "customers"} />
                    <Navigation.Item label="Juries" to={route("admin:juries")} condition={isAdmin} active={category === "juries"} />
                    <Navigation.Item label="Organizations" to={route("admin:organizations")} condition={isAdmin} active={category === "organizations"} />
                    <Navigation.Item label="Sections" to={route("admin:sections")} condition={isAdmin} active={category === "sections"} />
                    <Navigation.Item label="Awards" to={route("admin:awards")} condition={isAdmin} active={category === "awards"} />
                    <Navigation.Item label="Groups" to={route("admin:clubs")} condition={isAdmin} active={category === "clubs"} />
                    <Navigation.Item label="Logs" to={route("admin:logs")} condition={isAdmin} active={category === "logs"} />
                </Navigation>
            </NavigationWrapper>
            <ActionsWrapper>
                <Flex gap="5px">
                    <Navigation.Item label="Settings" icon={<SettingsIcon />} to={route("customer:settings")} condition={hasDetails && isCustomer} active={category === "settings"} />
                    <Navigation.Item label="Support" icon={<QuestionIcon />} condition={isCustomer && hasDetails} to={route("general:support")} newTab />
                    <Navigation.Item label="Log out" icon={<LogoutIcon />} onClick={logout} />
                </Flex>
            </ActionsWrapper>
            <HamburgerWrapper>
                <Hamburger opened={state === "visible"} action={openSidemenu} />
            </HamburgerWrapper>
        </HeaderContainer>
    )
}

export default React.memo(MainHeader)

// STYLES
const HeaderContainer = styled(Container)`
    position: relative;     
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    border-bottom: 1px solid ${colors.border};
    width: 100%;
    background: #fff;
`

const NavigationWrapper = styled.div`
    display: none;

    ${desktop(css`
        display: block;
        width: 100%;
        margin-left: 20px;
    `)}
`

const ActionsWrapper = styled.div`
    display: none;

    ${desktop(css`
        display: block;
    `)}
`

const LogoWrapper = styled.div`
    width: 48px;
    height: 48px;
`

const HamburgerWrapper = styled.div`
    ${desktop(css`
        display: none;
    `)}
`